import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { LoginPageApiService } from '../../../core/services/login-page-api.service';
import { NgIf } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'disable-notice',
    templateUrl: 'disable-notice.component.html',
    styleUrls: ['disable-notice.component.scss'],
    imports: [NgIf]
})
export class DisableNoticeComponent implements OnInit {
  public disableGreytHrLogo = false;
  private destroyRef = inject(DestroyRef);
  constructor(
    private _loginPageApiService: LoginPageApiService,
  ) { }
  public ngOnInit() {
    this._loginPageApiService.getLoginPage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.disableGreytHrLogo = res['disableGreytHrLogo'] || false;
      });
  }
}